import React, { useState, useEffect } from 'react';
import { Modal } from '@mui/material';
import PropTypes from 'prop-types';
import carIllustration from './images/car-illustration.png';
import zap from './images/zap.svg';
import { getMobileDeviceType } from '../../../utils/helpers/check-mobile-device';
import { APP_STORE_LINK, MOBILE_DEVICE_TYPE, PLAY_STORE_LINK } from '../../../constants/app-constants';
import { useSelector } from 'react-redux';
import { prepareGADataAndSendEvent } from '../../../tracking';

export const UPDATE_APP_MODAL_VARIANTS = {
    FORCE: 'force',
    SEMI_FORCE: 'semi-force'
};

const UPDATE_APP_MODAL_SHOWN = 'updateAppModalShown';

const UpdateAppModal = ({ variant = UPDATE_APP_MODAL_VARIANTS.FORCE,page }) => {
    const { user } = useSelector(state => state);
    const [isOpen, setIsOpen] = useState(false);
    const isSemiForceVariant = variant === UPDATE_APP_MODAL_VARIANTS.SEMI_FORCE;

    useEffect(() => {
        const hasBeenShown = sessionStorage.getItem(UPDATE_APP_MODAL_SHOWN);
        if (!hasBeenShown) {
            setIsOpen(true);
        }
    }, []);
    const handleUpdateClick = () => {
        const mobileDeviceType = getMobileDeviceType();
        const links={
            [MOBILE_DEVICE_TYPE.ANDROID]: PLAY_STORE_LINK,
            [MOBILE_DEVICE_TYPE.IOS]: APP_STORE_LINK,
        };
        try{
            window.open(links[mobileDeviceType || MOBILE_DEVICE_TYPE.ANDROID], '_unfencedTop');    
        } catch(e){
           console.error('Not able to open play store', e);
        }
    };

    const onClose = () => {
        if (isSemiForceVariant) {
            sessionStorage.setItem(UPDATE_APP_MODAL_SHOWN, 'true');
            setIsOpen(false);
            prepareGADataAndSendEvent(`semiForcedLater`, user, null,page);
        }
    };

    const handleMaybeLaterClick = () => {
        onClose();
    };

    const renderActionButtons = () => {
        const baseButtonClasses = 'h-[48px] rounded-[8px] font-semibold text-[14px] leading-[22px] uppercase transition-colors duration-200 shadow-none text-center';
        const primaryButtonClasses = `${baseButtonClasses} border-0 bg-[#ed6f00] hover:bg-[#d66300] text-white`;
        const secondaryButtonClasses = `${baseButtonClasses} bg-[#e8eefc] text-[#0032a6] hover:bg-[#dce7ff]`;

            return (
                <div className="flex w-full gap-4 justify-between">
                    {isSemiForceVariant && <button
                        type="button"
                        onClick={handleMaybeLaterClick}
                        className={`${secondaryButtonClasses} flex-1`}
                        style={{ border: '1px solid #0032A6' }}
                    >
                        MAYBE LATER
                    </button>}
                    <button
                        type="button"
                        onClick={handleUpdateClick}
                        className={`${primaryButtonClasses} flex-1`}
                    >
                        UPDATE NOW
                    </button>
                </div>
            );
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="update-app-modal"
            aria-describedby="update-app-description"
            className="flex items-end justify-center"
        >
            <div className="w-full outline-none">
                <div className="absolute inset-0 bg-black opacity-70" onClick={onClose} />

                <div className="relative bg-white rounded-tl-[20px] rounded-tr-[20px] pt-[20px] pb-[24px] px-[20px]">
                    {isSemiForceVariant && (
                        <button
                            type="button"
                            aria-label="Close"
                            onClick={onClose}
                            style={{border: 'none'}}
                            className="absolute -top-[32px] right-[20px] flex items-center justify-center w-8 h-8 rounded-full bg-white border-none!"
                        >
                            <span className="text-[#0f0f10] font-light  text-[18px] leading-none">&times;</span>
                        </button>
                    )}
                    <div className="flex flex-col gap-[20px] ">
                        <div className="relative flex items-center justify-center">
                                <img 
                                    src={carIllustration}
                                    alt="Car illustration"
                                    className="relative z-10 w-[158px] h-auto"
                                />
                        </div>
                        <div className="flex flex-col gap-[20px] items-center">
                            <div className="flex flex-col gap-[8px] items-center w-full">
                                <div className="flex items-center justify-center w-full">
                                    <span className="text-center font-semibold text-[18px] leading-[28px] text-[#001647]" >
                                        We supercharged our app!
                                    </span>
                                    <img src={zap} alt="zap" className="ml-[4px] w-[16px] h-[24px]"/>
                                </div>
                                
                                <div className="text-center w-full font-normal  leading-[22px] " >
                                    <p className="m-0 text-[14px] text-[#001647]">With new feature and a better experience. <br/> Update now to enjoy it all!</p>          
                                </div>
                            </div>

                            <div className="flex w-full">
                                {renderActionButtons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

UpdateAppModal.propTypes = {
    variant: PropTypes.oneOf(Object.values(UPDATE_APP_MODAL_VARIANTS)),
    page: PropTypes.string
};

export default UpdateAppModal;
